<template>
  <div>
    <el-table
v-loading="loading"
:data="data"
size="small">
      <el-table-column
label="STT"
width="80"
fixed="left"
align="center">
        <template slot-scope="scope">
          <span>
            {{ scope.row.stt }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        v-for="field in fields"
        :key="field.key"
        :prop="field.key"
        :label="field.label"
        :width="field.width"
      >
        <template slot-scope="scope">
          <span v-if="field.key === 'email'">
            {{ scope.row.account ? scope.row.account[field.key] : "" }}
          </span>
          <span v-if="field.key === 'role'">
            {{ scope.row.role && scope.row.role.translations && scope.row.role.translations.vi ? scope.row.role.translations.vi.name : scope.row.role.code }}
          </span>
          <span v-else-if="field.key === 'created'">
            {{ scope.row[field.key] | convertDateTime("HH:mm DD/MM/YYYY") }}
          </span>
          <span v-else>
            {{ scope.row[field.key] }}
          </span>
        </template>
      </el-table-column>
      <el-table-column
        label="Thao tác"
        width="120"
        fixed="right"
        align="center"
      >
        <template slot-scope="scope">
          <el-row
type="flex"
justify="center">
            <el-tooltip
content="Sửa"
effect="dark"
placement="top">
              <el-button
                icon="el-icon-edit"
                type="primary"
                size="small"
                circle
                @click="() => $emit('update', scope.row)"
              />
            </el-tooltip>
            <el-tooltip
content="Xoá"
effect="dark"
placement="top">
              <el-button
                icon="el-icon-delete"
                type="danger"
                size="small"
                circle
                @click="() => $emit('delete', scope.row)"
              />
            </el-tooltip>
          </el-row>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import CONSTANTS from "@/config/constants";

export default {
  name: "CardList",
  components: {},
  props: {
    data: Array,
    loading: Boolean,
  },
  data() {
    return {
      fileType: CONSTANTS.FILE_TYPE,
    };
  },
  computed: {
    fields() {
      return [
        {
          key: "email",
          label: "Địa chỉ email",
        },
        {
          key: "role",
          label: "Quyền hạn",
        },
        {
          key: "created",
          label: "Ngày tạo",
        },
      ];
    },
  },
  methods: {
    //
  },
};
</script>

<style lang="scss"></style>
